<template>
  <div>
    <div class="d-flex justify-content-between mb-2">
      <div class="d-flex align-items-center" style="gap: 10px">
        <div>
          <div class="section-title">{{ $tc("distributor", 2) }}</div>
          <div class="section-subTitle my-2">
            {{ $tc("distributor_dash_msg") }}
          </div>
        </div>

        <div>
          <b-form-input
            v-debounce:300="getDistributorsList"
            v-model="searchValue"
            placeholder="Search..."
          ></b-form-input>
        </div>
      </div>

      <div class="d-flex align-items-center">
        <div>
          <b-button
            v-if="$can('create', 'Distributors')"
            variant="default"
            to="add-distributor"
            class="btn-blue"
            >{{ $t("add") }}</b-button
          >
        </div>

        <div class="mx-2">
          <FilterByStatusDropdown
            :onSelect="
              (filterIsActive) => {
                filter_is_active = filterIsActive;
                getDistributorsList();
              }
            "
          />
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-if="Distributors.length > 0"
        v-for="(item, key) in Distributors"
        :key="key"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ $tc(item.d_company_name, 1) }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  v-if="$can('update', 'Distributors')"
                  @click="goToRoute('/distributor/edit-distributor', item)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="goToRoute('/distributor/view-distributor', item)"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1"></div>
            <div class="d-flex align-items-end">
              <StatusDot :status="item.d_is_active ? 'active' : 'inactive'" />
            </div>
          </div>
        </div>
      </div>
      <div v-if="Distributors.length == 0">
        <p>{{ $t("NoRecords") }}</p>
      </div>
    </div>

    <table class="list-view-table" v-if="listView" style="margin-bottom: 25px">
      <thead>
        <tr>
          <th class="text-left" style="width: 10%">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>

          <th class="text-left">
            <img
              v-if="this.columnName != 'd_company_name'"
              @click="onSortValue('d_company_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('d_company_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('d_company_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("distributor", 1) }}
          </th>
        </tr>
      </thead>
      <tbody v-if="Distributors.length > 0">
        <tr
          v-for="(item, key) in Distributors"
          :key="key"
          class="light_grey_back"
        >
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <StatusDot
                :status="item.d_is_active === 'Y' ? 'active' : 'inactive'"
              />
              <span
                v-if="$can('update', 'Distributors')"
                class="edit-icon ml-4 blue-icon"
                @click="goToRoute('/distributor/edit-distributor', item)"
                style="cursor: pointer"
                v-b-tooltip="'Edit'"
                tabindex="0"
              >
                <i class="edit-pen icon blue-icon"></i>
              </span>
              <span
                class="view-icon ml-2 blue-icon"
                @click="goToRoute('/distributor/view-distributor', item)"
                style="cursor: pointer"
                v-b-tooltip="'View'"
                tabindex="0"
              >
                <i class="icon-eye icon blue-icon"></i>
              </span>
            </div>
          </td>

          <td>{{ $tc(item.d_company_name, 1) }}</td>
        </tr>
      </tbody>
      <tbody v-if="Distributors.length == 0">
        <tr>
          <td colspan="2">
            <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div>
          </td>
        </tr>
      </tbody>
    </table>

    <b-pagination
      v-if="Distributors.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Distributors from "@/helper/formJSONMaster/Distributors";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      gridView: false,
      listView: true,
      Methods: Distributors.Methods,
      Distributors: [],
      customErrors: {
        message: "",
      },
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",

      debounce: null,
      searchValue: "",
      searchKey: "d_company_name",
      filter_is_active: "Y",
    };
  },
  beforeMount() {
    this.getviewingnumber();
    this.getDistributorsList();
  },
  mounted() {
    this.getDistributorsList();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getDistributorsList();
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getDistributorsList();
      } else {
        this.currentPage = event;
        this.getDistributorsList();
      }
    },
    goToRoute: function (path, item) {
      const { d_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: d_id,
        },
      });
    },
    getDistributorsList: function () {
      let loader = this.$loading.show();
      this.Distributors = [];
      let body = this.getRequestBody("GET", undefined, this.Methods);
      body.url += `?limit=${this.perPage}&currentPage=${this.currentPage}&orderBy=${this.orderby}&columnName=${this.columnName}&searchValue=${this.searchValue}&searchKey=${this.searchKey}&filter_is_active=${this.filter_is_active}`;
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Distributors = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.customErrors.message = data.message;
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
          setTimeout(() => {
            loader.hide();
          }, 100);
        })
        .catch((error) => {
          // Show Catch Error
          setTimeout(() => {
            loader.hide();
          }, 100);
          console.log("show error :", error);
        });
    },

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/DistributorContainer/DistributorsComponents/distributors.vue